// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //c: "mi3xkNpDMBw=",
  //k: "OLCZ5OHN91o=",

  //  c: 'nfDNqIbKwUw=',
  // k: 'eLPNaD/X6SLbC2ZMUmlHTQ=='
  //  apiUrl: 'https://portal2websiteapi.cloudcampus24.com',

  // acps
  // c:'f71rhOpQDPM=',
  // k:'2bqSmJyURJDdeBnOb5BUYw==',



  c: '36KV+Ht7OxE=',
  k: '7n0RIC6VE7bVS5X9E7CmNQ==',
  //  c: "uiqDWJh7IFw=",
  //   k: "U0/2/2aPuyLdeBnOb5BUYw==",



  //c: "cicRrsStvcM=",
  //k: "GSJk0Rr4amQ=",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
